import { useAuth } from "../context/AuthContext.tsx";

// src/components/PermissionGate.tsx
interface PermissionGateProps {
    permission: string;
    children: React.ReactNode;
    fallback?: React.ReactNode;
  }
  
  export const PermissionGate: React.FC<PermissionGateProps> = ({ 
    permission, 
    children, 
    fallback = null 
  }) => {
    const { hasPermission } = useAuth();
    return hasPermission(permission) ? <>{children}</> : <>{fallback}</>;
  };